import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { HeartHandshake, Users2, ShieldCheck } from "lucide-react";

export default function HowItWorks() {
  return (
    <div>
      <Navbar />
      <div className="max-w-5xl mx-auto px-6 py-14 sc-fade-in">
        <div className="text-xs uppercase tracking-wider font-semibold text-slate-500">Le concept</div>
        <h1 className="text-3xl sm:text-5xl font-extrabold tracking-tight text-slate-900">Comment fonctionne TymCoach ?</h1>
        <p className="mt-4 text-lg text-slate-600">TymCoach transforme les créneaux libres des salles en opportunités pour les coachs et les particuliers. Trois rôles, un même objectif : rendre le sport plus flexible.</p>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          <Card icon={<HeartHandshake className="w-5 h-5" />} color="emerald" title="Particulier" body="Vous êtes anxieux à l'idée d'un abonnement mensuel ? Réservez une séance à la fois, dans une vraie salle, avec un coach de confiance." />
          <Card icon={<Users2 className="w-5 h-5" />} color="orange" title="Coach" body="Découvrez de nouvelles salles sans engagement de loyer mensuel. Proposez à vos clients des créneaux dans les meilleurs studios de la ville." />
          <Card icon={<ShieldCheck className="w-5 h-5" />} color="indigo" title="Responsable de Salle" body="Publiez vos créneaux vacants et transformez-les en chiffre d'affaires. Validez ou refusez chaque coach selon votre niveau de coopération." />
        </div>

        <h2 className="mt-16 text-2xl sm:text-3xl font-bold text-slate-900">Le workflow de validation</h2>
        <ol className="mt-6 space-y-4 text-slate-700">
          <li><b>1.</b> La salle publie un créneau libre (jour, heure, équipements, tarif).</li>
          <li><b>2.</b> Un coach propose une réservation pour son client.</li>
          <li><b>3.</b> La salle reçoit une notification (in-app + email logué).</li>
          <li><b>4.</b> La salle accepte ou refuse (avec motif facultatif).</li>
          <li><b>5.</b> Le coach et le client sont notifiés instantanément.</li>
          <li><b>6.</b> Une messagerie intégrée permet d'organiser la séance.</li>
        </ol>
      </div>
      <Footer />
    </div>
  );
}

function Card({ icon, color, title, body }) {
  const map = { emerald: "border-emerald-500/20", orange: "border-orange-500/20", indigo: "border-indigo-500/20" }[color];
  return (
    <div className={`sc-card ${map}`}>
      <div className="w-10 h-10 rounded-xl bg-slate-900 text-white grid place-items-center">{icon}</div>
      <div className="mt-3 font-bold text-slate-900">{title}</div>
      <p className="mt-2 text-sm text-slate-700">{body}</p>
    </div>
  );
}
